import Grid from '@material-ui/core/Grid'
import React, { PropsWithChildren } from 'react'
import styled from 'styled-components'
import { irem } from 'utils'
import { ProductCardGridWithPadding } from './styledProductCard'

export type ProductCardFeatureProps = React.ComponentProps<typeof Grid> & {
  //
}

export const CardFeatureHeader = styled.p`
    margin: 0 0 ${props => props.theme.typography.pxToRem(14)};
    color: ${props => props.theme.palette.text.primary};
    font-size: ${props => props.theme.typography.pxToRem(14)};
    font-weight: 500;
    background: ${props => props.theme.custom.colors.orange};
    padding: ${irem(7)} ${irem(31 - 18)};
    line-height: ${irem(27)};
    border-radius: ${irem(5)};
    
    &&&& {
        margin-bottom: ${irem(10)};
        
        ${props => props.theme.breakpoints.up('sm')} {
            margin-bottom: ${irem(15)};
        }
    }
    
    ${props => props.theme.breakpoints.up('sm')} {
        font-size: ${props => props.theme.typography.pxToRem(16)};
        padding: ${irem(12)} ${irem(20)};
    }
`

export const ProductCardFeature: React.FC<PropsWithChildren<ProductCardFeatureProps>> = ({ children, item=true, ...props }) => {
  return (
    <>
      <Grid item>
        <CardFeatureHeader>Key features & benefits</CardFeatureHeader>
      </Grid>
      <ProductCardGridWithPadding item={item} {...props} data-same-height-alt>
        <Grid container direction={'column'} alignItems={'flex-start'} justifyContent={'flex-start'}>
          <Grid item>
            { children }
          </Grid>
        </Grid>
      </ProductCardGridWithPadding>
    </>
  )
}
